<form [formGroup]="allowSubstitutionForm">
    <form-input
        [formControlName]="id"
        inputType="checkbox"
        (change)="handleAllowSubstitutionToggle($event)">
        <label i18n="@@product-allowSubstitutes" [for]="id" label>
            <ng-content select="[label]"></ng-content>
        </label>
    </form-input>
</form>